// extracted by mini-css-extract-plugin
export default {"container":"info-box_container__IY789","content":"info-box_content__Gq143","mobileTitle":"info-box_mobileTitle__D4y9w"};